import { render, staticRenderFns } from "./FormDetailActions.vue?vue&type=template&id=dc12ba9a&scoped=true&"
import script from "./FormDetailActions.vue?vue&type=script&lang=js&"
export * from "./FormDetailActions.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailActions.vue?vue&type=style&index=0&id=dc12ba9a&prod&scoped=true&lang=scss&"
import style1 from "./FormDetailActions.vue?vue&type=style&index=1&id=dc12ba9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc12ba9a",
  null
  
)

export default component.exports